import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { useIsFramedCentredStep } from '../hooks/useIsFramedCentredStep';
import { useIsStepDataValid } from '../hooks/useIsStepDataValid';
import { Step } from '../views/Step';
import CreateAccountTermsOfService from './CreateAccountTermsOfService';
import NextButton from './NextButton';
import { usePrivacyBanner } from './usePrivacyBanner';
import { devices } from '../styles/viewports.styles';
const StyledNextButtonWrapper = styled.div.withConfig({
  displayName: "NextButtonWrapper__StyledNextButtonWrapper",
  componentId: "sc-5kgt8d-0"
})(["", " ", " @media ", "{padding-top:", ";", "}"], props => props.isFramedCentredStep && props.currentStep !== Step.LandingPage && `top: 15px;
    position: relative;`, props => props.isFramedCentredStep && props.currentStep === Step.HubletSelection && `top: 0; padding-top: ''`, devices.desktop, props => props.isFramedCentredStep && props.currentStep !== Step.LandingPage ? '30px;' : '', props => props.isFramedCentredStep && 'top: 0;');

const NextButtonWrapper = (_ref) => {
  let {
    onClick,
    enabled,
    label,
    dataSelenium
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["onClick", "enabled", "label", "dataSelenium"]);

  const {
    shouldShowToSNonOptionalStep,
    shouldShowToSOptionalStep
  } = usePrivacyBanner();
  const {
    currentStep
  } = useCurrentStep();
  const customButtonLabelI18n = `views.${currentStep}.buttonLabel`;
  const isStepDataValid = useIsStepDataValid(currentStep);
  const isEnabled = typeof enabled === 'boolean' ? enabled : isStepDataValid;
  let buttonLabel = // eslint-disable-next-line no-nested-ternary
  label && isValidI18nKey(label) ? label : isValidI18nKey(customButtonLabelI18n) ? customButtonLabelI18n : 'button.next';
  if (shouldShowToSNonOptionalStep || shouldShowToSOptionalStep) buttonLabel = 'button.createAccount';

  const onSubmit = event => {
    event.preventDefault();
    onClick();
  };

  const {
    isFramedCentredStep
  } = useIsFramedCentredStep();
  return /*#__PURE__*/_jsxs(StyledNextButtonWrapper // @ts-expect-error Expression produces a union type that is too complex to represent.
  , {
    currentStep: currentStep,
    isFramedCentredStep: isFramedCentredStep,
    children: [/*#__PURE__*/_jsx(NextButton, Object.assign({
      buttonLabel: buttonLabel,
      currentStep: currentStep,
      dataSelenium: dataSelenium,
      isEnabled: isEnabled,
      isStepDataValid: isStepDataValid,
      label: buttonLabel,
      onSubmit: onSubmit
    }, props)), shouldShowToSNonOptionalStep && /*#__PURE__*/_jsx(CreateAccountTermsOfService, {})]
  });
};

export default NextButtonWrapper;